export interface CreatorUpdatesSignupData {
  email: string;
  source: 'source_links' | 'source_store';
}

const KIT_FORM_ID = process.env.REACT_APP_KIT_FORM_ID || '9751653';
const KIT_FORM_ACTION = process.env.REACT_APP_KIT_FORM_ACTION;

export const submitCreatorUpdatesSignup = async ({
  email,
  source,
}: CreatorUpdatesSignupData) => {
  if (!KIT_FORM_ID && !KIT_FORM_ACTION) {
    throw new Error('Creator Updates signup is being connected. Please check back soon.');
  }

  const endpoint = KIT_FORM_ACTION || `https://app.kit.com/forms/${KIT_FORM_ID}/subscriptions`;
  const formData = new FormData();
  formData.append('email_address', email);
  formData.append('fields[source]', source);
  formData.append('fields[lead_magnet]', 'client_project_folder_guide');
  formData.append('tags[]', source);
  formData.append('tags[]', 'interest_creator_tools');
  formData.append('tags[]', 'interest_client_project_folder_guide');

  const response = await fetch(endpoint, {
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Could not subscribe right now. Please try again later.');
  }

  return { success: true };
};
